/* eslint-disable max-len */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef } from 'react';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize,
  ExcelExport,
  ForeignKey,
  PdfExport,
} from '@syncfusion/ej2-react-grids';
import { Link, useNavigate } from 'react-router-dom';

import { DropDownListComponent, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-react-popups';

import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import scribeHow from '../data/scribehow.png';
import { useStateContext } from '../contexts/ContextProvider';

import { Header } from '../components';
import { coreBodyEventsGrid, coreVitalEventsGrid, coreTempEventsGrid, reportInvGrid, reportAuditGrid, reportNotificationsGrid, reportComplianceGrid, reportWorkResteGrid, reportVitalsGrid } from '../data/dummy';
import logo from '../data/logo.jpg';
import './Zackat.css';

const Reports = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let org = localStorage.getItem('organization');
  if (!usr || !org) {
    // Redirect
    navigate('/login?landing=reports');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  org = JSON.parse(org);

  const { zRenderMode, boss } = useStateContext();
  const [associateid, setAssociateId] = useState('');
  const [devceid, setDeviceId] = useState('');
  const editing = { allowDeleting: false, allowEditing: false };
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [monthlyBattery, setMonthlyBattery] = useState(false);
  const [monthlyBilling, setMonthlyBilling] = useState(false);
  const [mySchedule, setMySchedule] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [myBattery, setMyBattery] = useState('');
  const [myOrg, setMyOrg] = useState('');

  const handleToolbarClick = (args) => {
    if (args && args.target && args.target.textContent && args.target.textContent === 'Scheduler') {
      setIsDialogVisible(true);
    } else {
      setIsDialogVisible(false);
    }
  };
  const [corebody, setCoreBody] = useState(false);
  const [oxygen, setOxygen] = useState(false);
  const [hydration, setHydration] = useState(false);
  const [temperature, setTemperature] = useState(false);
  const [respiratory, setRespiratory] = useState(false);
  const [inventory, setInventory] = useState(false);
  const [associates, setAssociates] = useState(false);
  const [audit, setAudit] = useState(false);
  const [auditDialog, setAuditDialog] = useState(true);
  const [auditid, setAuditId] = useState('');
  const [auditData, setAuditData] = useState([]);
  const [notifications, setNotifications] = useState(false);
  const [compliance, setCompliance] = useState(false);
  const [workrest, setWorkRest] = useState(false);
  const [vitals, setVitals] = useState(false);
  const [scheduler, setScheduler] = useState(false);
  const [selectedReport, setReport] = useState('');
  const [selectedMeasurement, setMeasurement] = useState('');
  const [tableData, setTableData] = useState([]);
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  const pdf = { text: 'PDF Export', tooltipText: 'PDF', prefixIcon: 'e-export-pdf', id: 'pdf', disabled: false };

  const aud = { text: 'Audit', tooltipText: 'Audit', prefixIcon: 'e-full-screen', id: 'aud', visible: boss };
  const toolbarOptions = [excel, pdf, 'Search'];
  const toolbarOptionsAudit = [excel, pdf, aud, 'Search'];
  const measurements = [
    'CoreBody',
    'Temperature',
    'HeartRate',
    'Respiratory',
    'Oxygen',
  ];
  const allReports = [
    'Audit',
    'Associates',
    'Billing',
    'Compliance',
    'Inventory',
    'Low Battery',
    'Managers',
    'Notifications',
    'Vitals',
    'WorkRest',
  ];

  const monthlyReports = [
    'Associates',
    'Billing',
    'Compliance',
    'Inventory',
    'Low Battery',
    'Managers',
    'Notifications',
    'Vitals',
    'WorkRest',
  ];
  const header = () => (
    <div><h1>Audit {auditid} </h1></div>
  );
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedOrg = JSON.parse(localStorage.getItem('organization'));

  const organizations = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(data.organizations),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  const saveSchedule = () => {
    const postSchedule = async () => {
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/reports?report=schedule&_id=${usr._id}&organizationid=${org.id}`,
        method: 'POST',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
        data: { userid: usr._id, reports: mySchedule, battery: myBattery, orgLevel: myOrg, organizationid: org.id },
      })
        .then((response) => {
          DialogUtility.alert(response.data.response);
        })
        .catch(() => {
        });
      setIsDialogVisible(false);
    };
    postSchedule();
  };

  const buttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveSchedule();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setIsDialogVisible(false);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  useEffect(() => {
    if (data && data.role && data.role.reports && data.role.reports.permissions) {
      if (data.role.reports.permissions.includes('Scheduler')) {
        setScheduler(true);
      } else {
        setScheduler(false);
      }
    }
  }, [data]);
  useEffect(() => {
    const auditReport = async () => {
      if (auditid && auditid.length > 0) {
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=audit&_id=${usr._id}&organizationid=${org.id}&auditid=${auditid}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setAuditData(response.data);
            setAuditDialog(!auditDialog);
          })
          .catch(() => {
          });
      }
    };
    auditReport();
  }, [auditid]);

  const auditTemplate = () => (
    <div className="pt-2 relative mx-auto text-gray-600 zackat-divalh">
      <pre>{JSON.stringify(auditData.audit, null, 2)}</pre>
    </div>
  );

  const auditbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setAuditDialog(!auditDialog);
        setAuditId('');
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];

  const minDate = new Date('10/01/2024 00:00 AM');
  let maxDate = new Date();
  maxDate = new Date(maxDate.setDate(maxDate.getDate() + 1));
  let fromDate = new Date();
  fromDate = new Date(fromDate.setDate(maxDate.getDate() - 1));
  const toDate = new Date();
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [fromHere, setFromHere] = useState(fromDate);
  const [toHere, setToHere] = useState(toDate);
  const [battery, setBattery] = useState('20');
  const [nameOrDevice, setNameOrDevice] = useState(null);
  const grid = useRef(null);
  function measurementSelect(e) {
    setMeasurement(e.value);
  }
  useEffect(() => {
    let maxDate = new Date();
    maxDate = new Date(maxDate.setDate(maxDate.getDate() + 1));
    maxDate.setHours(23, 59);
    let fromDate = new Date();
    fromDate = new Date(fromDate.setDate(maxDate.getDate() - 1));
    fromDate.setUTCHours(0, 0);
    setFrom((fromDate.getTime() / 1000).toFixed(0));
    setTo((maxDate.getTime() / 1000).toFixed(0));
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };
  useEffect(() => {
    async function reportSelect() {
      setTableData([]);
      if (notifications && selectedReport !== 'Notifications') {
        setNotifications(false);
      }
      if (compliance && selectedReport !== 'Compliance') {
        setCompliance(false);
      }
      if (workrest && selectedReport !== 'WorkRest') {
        setWorkRest(false);
      }
      if (vitals && selectedReport !== 'Vitals') {
        setVitals(false);
      }

      if (selectedReport === 'Core Measurements') {
        setCoreBody(true);
      } else {
        setCoreBody(false);
      }
      if (selectedReport === 'Low Battery') {
        setInventory(true);
      } else {
        setInventory(false);
      }
      if (selectedReport === 'Notifications') {
        setNotifications(true);
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=notifications&_id=${usr._id}&organizationid=${org.id}&from=${from}&to=${to}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data && response.data.notifications) {
              setTableData(response.data.notifications);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        setAssociates(false);
      }
      if (selectedReport === 'Compliance') {
        setCompliance(true);
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=compliance&_id=${usr._id}&organizationid=${org.id}&from=${from}&to=${to}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data && response.data.compliance) {
              setTableData(response.data.compliance);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        setAssociates(false);
      }
      if (selectedReport === 'WorkRest') {
        setWorkRest(true);
        setTableData([]);
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=workrest&_id=${usr._id}&organizationid=${org.id}&from=${from}&to=${to}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data && response.data.workrest) {
              setTableData(response.data.workrest);
            } else {
              setTableData([]);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        setAssociates(false);
      }
      if (selectedReport === 'Vitals') {
        setVitals(true);
        setTableData([]);
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=vitals&_id=${usr._id}&organizationid=${org.id}&from=${from}&to=${to}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data && response.data.vitals) {
              setTableData(response.data.vitals);
            } else {
              setTableData([]);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        setAssociates(false);
      }
      if (selectedReport === 'Audit') {
        setAudit(true);
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=audit&_id=${usr._id}&organizationid=${org.id}&from=${from}&to=${to}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setTableData(response.data.audit);
          })
          .catch(() => {
          });
      } else {
        setAudit(false);
      }
    }
    reportSelect();
  }, [to, from, selectedReport]);
  /*
  function setDesiredBattery(e) {
    if (e && e.value && e.value.length >= 2) {
      setBattery(e.value);
    }
  }
*/
  useEffect(() => {
    const batteryReport = async () => {
      if (selectedReport === 'Low Battery' && battery && battery.length >= 2) {
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=lowbattery&_id=${usr._id}&from=${from}&to=${to}&battery=${battery}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setTableData(response.data.inventory);
          })
          .catch(() => {
          });
      }
    };
    batteryReport();
  }, [battery, inventory, toHere, fromHere]);
  async function deviceSelect(e) {
    let stringData = '';
    for (let i = 0; i < e.value.length; i += 1) {
      stringData += `&devices=${e.value[i]}`;
    }
    setDeviceId(e.value);
    axios({
      url: `${REACT_APP_API_ENDPOINT}/reports?report=lowbattery&_id=${usr._id}${stringData}&from=${from}&to=${to}&battery={batt}`,
      method: 'get',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        setTableData(response.data.inventory);
      })
      .catch(() => {
      });
  }
  async function associateSelect(e) {
    if (!e || !e.value) {
      return;
    }
    setAssociateId(e.value);
    axios({
      url: `${REACT_APP_API_ENDPOINT}/reports?report=corebody&associateid=${e.value}&_id=${usr._id}&from=${from}&to=${to}&measurement=${selectedMeasurement}`,
      method: 'get',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (selectedMeasurement === 'CoreBody') {
          setTableData(response.data.coreBody);
        } else {
          setTableData(response.data.coreVitals);
        }
      })
      .catch(() => {
      });
  }
  useEffect(() => {
    const getCoreBody = async () => {
      if (corebody && nameOrDevice && nameOrDevice.length > 0) {
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=corebody&name=${nameOrDevice}&_id=${usr._id}&from=${from}&to=${to}&measurement=${selectedMeasurement}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (selectedMeasurement === 'CoreBody') {
              setTableData(response.data.coreBody);
            } else {
              setTableData(response.data.coreVitals);
            }
          })
          .catch(() => {
          });
      }
    };
    getCoreBody();
  }, [nameOrDevice, toHere, fromHere, selectedMeasurement]);

  function dateChanged(e) {
    if (!e || !e.value) {
      return;
    }
    const d1 = new Date(e.value);
    if (e.target.id === 'fromdate') {
      setFrom((d1.getTime() / 1000).toFixed(0));
      setFromHere(d1);
    }
    if (e.target.id === 'todate') {
      setTo((d1.getTime() / 1000).toFixed(0));
      setToHere(d1);
    }
    /*
    if (selectedReport === 'Audit') {
      reportSelect({ value: 'Audit' });

    } else if (selectedReport === 'Core Measurements') {
      associateSelect({ value: associateid });
    } else if (selectedReport === 'Notifications') {
      reportSelect({ value: 'Notifications' });
    } else if (selectedReport === 'Compliance') {
      reportSelect({ value: 'Compliance' });
    } else if (selectedReport === 'WorkRest') {
      reportSelect({ value: 'WorkRest' });
    }
    */
    if (grid && grid.current) {
      grid.current.refresh();
    }
  }
  const capitalizeWords = (str) => str
    .toLowerCase() // Optional: forces other letters to lowercase
    .split(' ') // Split string into an array of words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each
    .join(' '); // Join back into a single string

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.report = 'reports';
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/reports?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      setData(mydata);
      if (mydata.monthlyReports) {
        const myReports = [];
        setSchedule(mydata.monthlyReports);
        mydata.monthlyReports.forEach((r) => {
          if (r.battery && r.battery.length > 0) {
            setMonthlyBattery(true);
            setMyBattery(r.battery);
          }
          if (r.orgLevel && r.orgLevel.length > 0) {
            setMonthlyBilling(true);
            setMyOrg(r.orgLevel);
          }
          myReports.push(capitalizeWords(r.report));
        });
        setMySchedule(myReports);
      }
      setLoading(false);
    };
    dataFetch();
  }, []);
  /*
  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        let { result } = reader;

        // Ensure PNG strings are modified for Syncfusion's strict JPEG expectation
        if (result && result.startsWith('data:image/png')) {
          result = result.replace('data:image/png', 'data:image/jpeg');
        }

        resolve(result);
      };
      reader.onerror = (err) => reject(err);
    });
  };
  */
  const clickHandler = async (args) => {
    if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_${selectedReport}_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Audit') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        setAuditId(selectedRecords[0]._id);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Automation') {
      DialogUtility.alert('Automation');
    } else if (grid && args.item.properties.text === 'PDF Export') {
      // eslint-disable-next-line no-param-reassign
      args.cancel = true;
      // 1. Prepare your image as a Base64 string
      const runDate = formatDate(new Date());
      // const base64Logo = String(await getBase64FromUrl(logo));
      // console.log('clickHandler', base64Logo);
      try {
        const pdfExportProperties = {
          fileName: `PDFExport_${selectedReport}_${new Date().toISOString()}.pdf`,
          pageOrientation: 'Landscape',
          header: {
            fromTop: 0,
            height: 100,
            contents: [
              {
                type: 'Text',
                value: `Sensocore ${selectedReport} REPORT`,
                position: { x: 0, y: 30 },
                style: { textBrushColor: '#1A1A1A' },
              },
              /*
              {
                type: 'Image',
                src: base64Logo, // Insert your Base64 string here
                position: { x: 450, y: 20 }, // X and Y coordinates in points
                size: { height: 75, width: 75 }, // Image dimensions in points
              },
              */
              {
                type: 'Text',
                value: `Run: ${usr.email} generated by Zackat Labs Inc.`,
                position: { x: 600, y: 50 },
                style: { textBrushColor: '#F6821E' },
              },
              {
                type: 'Text',
                value: `From ${formatDate(fromHere)} to ${formatDate(toHere)}`,
                position: { x: 0, y: 80 },
                style: { textBrushColor: '#1A1A1A' },
              },
            ],
          },
          footer: {
            fromBottom: 10, // Distance from the bottom of the page
            height: 60, // Height of the footer section
            contents: [
              {
                type: 'PageNumber',
                format: 'Page {$current} of {$total}',
                position: { x: 400, y: 35 },
                style: { textBrushColor: '#666666' },
              },
              {
                type: 'Text',
                value: `Run Date: ${runDate}`,
                position: { x: 600, y: 35 },
                style: { textBrushColor: '#666666' },
              },
            ],
          },
        };
        grid.current.pdfExport(pdfExportProperties);
      } catch (error) {
        console.error('Error generating PDF with custom image header:', error);
      }
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  const FilterOptions = {
    type: 'Menu',
  };
  const measurementOptions = () => (
    <div className="flex">
      <span className="e-icons e-filter-1" /><DropDownListComponent id="ddlmelement" dataSource={measurements} placeholder="Select a measurement" value={selectedMeasurement} onChange={measurementSelect} />
    </div>
  );
  const reportOptions = () => (
    <div className="flex">
      <span className="e-icons e-freeze-column" /><DropDownListComponent id="ddlelement" dataSource={data.reports} placeholder="Select a report" value={selectedReport} onChange={(e) => { setReport(e.value); }} />
    </div>
  );
  const fromDateOptions = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      {(corebody || audit || notifications || compliance || workrest || vitals || associates || inventory) && (
      <DateTimePickerComponent
        id="fromdate"
        onChange={(e) => {
          setFrom((e.value.getTime() / 1000).toFixed(0));
          setFromHere(e.value);
        }}
        placeholder="Select From Date/Time"
        defaultValue={fromHere}
        min={minDate}
        max={maxDate}
      />
      )}
    </div>
  );
  const toDateOptions = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      {(corebody || audit || notifications || compliance || workrest || vitals || associates || inventory) && (
      <DateTimePickerComponent
        id="todate"
        onChange={(e) => {
          setTo((e.value.getTime() / 1000).toFixed(0));
          setToHere(e.value);
        }}
        placeholder="Select To Date/Time"
        defaultValue={toHere}
        min={minDate}
        max={maxDate}
      />
      )}
    </div>
  );
  const deviceOptions = () => (
    <div className="flex">
      {/*
      <span className="e-icons e-bring-to-front" />{inventory && <MultiSelectComponent id="deviceSelect" dataSource={data.devices} fields={fields} width={350} onChange={deviceSelect} value={devceid} placeholder="Select device(s)" />}
      */}
      {inventory && (
      <div className="mt-2 e-mygrid">
        <TextBoxComponent
          className="mt-2"
          placeholder="Level"
          value={battery}
          title="battery level "
          floatLabelType="Auto"
          onChange={(e) => { if (e.value && e.value.length === 2) { setBattery(e.value); } }}
        />
      </div>
      )}
    </div>
  );

  const searchThis = (args) => {
    const search = document.getElementById('associatesearch');
    if (search && search.value && search.value.length > 0) {
      setNameOrDevice(search.value);
    }
  };
  const handleKeyDown = (e) => {
    // Check if the pressed key is "Enter"
    if (e.key === 'Enter') {
      // Prevent the default form submission behavior
      e.preventDefault();
      // Perform your search or submission logic here
      searchThis(e);
      // Optional: Clear the textbox after searching
      // setValue('');
    }
  };

  const inputStyle = { width: '400px', display: 'inline-block', float: 'right' };
  const searchComponent = () => (
    <div className="pt-2 relative mx-auto text-gray-600">
      <input
        className="border-2 border-gray-300 bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none searchtext"
        type="search"
        name="search"
        style={inputStyle}
        id="associatesearch"
        title="associate name or device"
        defaultValue={nameOrDevice}
        placeholder="Search associate, device or case sensitive name"
        onKeyDown={handleKeyDown}
      />
      <button type="button" aria-label="Search" title="" className="absolute right-0 top-0 mt-5 mr-4" onClick={searchThis}>
        <svg
          className="text-gray-600 h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          xmlSpace="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </button>
    </div>
  );

  const associateOptions = () => (
    <div className="flex">
      {/*
      <span className="e-icons e-people" />{corebody && associateid !== '' && <DropDownListComponent id="associateSelect" dataSource={data.associates} fields={associateFields} width={350} onChange={associateSelect} value={associateid} placeholder="Select Inventory (Associate)" />}
      */}
    </div>
  );
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Select_Low_Battery_Report_and_Update_Level__TVApiwmJRWWc-ORjmCMEug"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Dashboards" title={`Reports : ${selectedReport}`} />
      </div>
      <ToolbarComponent id="toolbar" onClick={handleToolbarClick}>
        <ItemsDirective>
          <ItemDirective
            float="left"
            text="Scheduler"
            tooltipText="Monthly Scheduler"
            prefixIcon="e-history"
            visible={scheduler}
            onClick={() => { DialogUtility.alert('Schedule Month Reports'); }}
          />
          <ItemDirective type="Separator" />
          <ItemDirective template={reportOptions} />
          <ItemDirective type="Separator" />
          {selectedReport === 'Core Measurements' && <ItemDirective template={measurementOptions} />}
          <ItemDirective type="Separator" />
          {(selectedReport === 'Core Measurements' || audit || notifications || compliance || workrest || vitals || associates || inventory) && <ItemDirective template={fromDateOptions} />}
          {(selectedReport === 'Core Measurements' || audit || notifications || compliance || workrest || vitals || associates || inventory) && <ItemDirective type="Separator" />}
          {(selectedReport === 'Core Measurements' || audit || notifications || compliance || workrest || vitals || associates || inventory) && <ItemDirective template={toDateOptions} />}
          {(selectedReport === 'Core Measurements' || audit || notifications || compliance || workrest || vitals || associates || inventory) && <ItemDirective type="Separator" />}
          {inventory && <ItemDirective template={deviceOptions} />}
          {inventory && <ItemDirective type="Separator" />}
          {selectedReport === 'Core Measurements' && <ItemDirective template={associateOptions} />}
          {selectedReport === 'Core Measurements' && <ItemDirective text="Search" template={searchComponent} style={{ float: 'right !important' }} />}
        </ItemsDirective>
      </ToolbarComponent>

      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            {tableData && tableData.length !== 0 && (corebody || inventory || associates || audit || notifications || compliance || workrest || vitals) && (
            <GridComponent
              dataSource={tableData}
              width="auto"
              allowPaging
              allowSorting
              editSettings={editing}
              toolbar={audit ? toolbarOptionsAudit : toolbarOptions}
              toolbarClick={clickHandler}
              enableHover={false}
              pageSettings={{ pageSize: 30 }}
              allowResizing
              allowFiltering={false}
              filterSettings={FilterOptions}
              allowExcelExport
              allowPdfExport
              showColumnChooser
              allowTextWrap
              ref={grid}
              enableAdaptiveUI
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {corebody && selectedMeasurement === 'CoreBody' && coreBodyEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'Temperature' && coreTempEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'HeartRate' && coreVitalEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'Respiratory' && coreVitalEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'Oxygen' && coreVitalEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {inventory && reportInvGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {notifications && reportNotificationsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {compliance && reportComplianceGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {workrest && reportWorkResteGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {vitals && reportVitalsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {audit && reportAuditGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {!corebody && !compliance && (
                <ColumnDirective
                  field={audit ? 'audit.organizationid' : 'organizationid'}
                  headerText="Organization"
                  width="150"
                  textAlign="Left"
                  editType="dropdownedit"
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  dataSource={organizations.params.dataSource}
                />
                )}

              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize, ForeignKey, ExcelExport, PdfExport]} />
            </GridComponent>
            )}
          </div>
        </div>
      </div>
      {!auditDialog && (
        <DialogComponent
          header={header}
          content={auditTemplate}
          buttons={auditbuttons}
          width="55%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => {
            setAuditDialog(!auditDialog);
            setAuditId('');
          }}
          close={() => {
            setAuditDialog(!auditDialog);
            setAuditId('');
          }}
        />
      )}
      <DialogComponent
        header="Automation Monthly Reports Scheduler"
        visible={isDialogVisible}
        width="500px"
        buttons={buttons}
        showCloseIcon
        close={() => setIsDialogVisible(false)}
      >
        <div>
          <p>Scheduler for Automated Monthly Reports</p>
          <div className="mt-2">
            <MultiSelectComponent
              id="monreports"
              dataSource={boss ? allReports : monthlyReports}
              width={350}
              floatLabelType="Auto"
              placeholder="Select Monthly Report(s)"
              value={mySchedule}
              onChange={(e) => {
                setMySchedule(e.value);
                if (e.value.includes('Low Battery')) {
                  setMonthlyBattery(true);
                } else {
                  setMonthlyBattery(false);
                }
                if (e.value.includes('Billing')) {
                  setMonthlyBilling(true);
                } else {
                  setMonthlyBilling(false);
                }
              }}
            />
            <div style={{ display: monthlyBattery ? 'block' : 'none' }}>
              <TextBoxComponent
                className="mt-4"
                placeholder="Battery Level"
                value={myBattery}
                title="Battery level for Low Battery Report"
                onChange={(e) => { setMyBattery(e.value); }}
                floatLabelType="Auto"
              />
            </div>
            <div style={{ display: monthlyBilling ? 'block' : 'none' }}>
              <DropDownListComponent
                id="monBilling"
                dataSource={boss ? ['all', 'parent'] : ['parent']}
                floatLabelType="Auto"
                placeholder="Select Organization Level"
                disabled={!monthlyBilling}
                value={myOrg}
                onChange={(e) => { setMyOrg(e.value); }}
              />
            </div>
          </div>
        </div>
      </DialogComponent>
    </div>
  );
};
export default Reports;
